<template lang="pug">
div
    modal(v-show="isShowModal_",:titulo="nameModulo.toUpperCase() + ': ' + ItemSelect.NameUser" bindClass="col-md-7 col-sm-12" , @close="isShowModal_=false")
        div(slot='body')  
            .card-body.bg-light  
                .form-row                    
                    .col-md-6.col-sm-12
                        label Documentos 
                        select.form-control.form-control-sm(v-if="tablePending", v-model="parameterInsert.IdDocType" )
                                option(v-for="(item,index) in tablePending", :value="item.IdDocType") {{item.NameDocument}} 
                    .col-md-3.col-sm-12
                        label Activo
                        select.form-control.form-control-sm(v-model="parameterInsert.Active" )
                                            option(value=1) Activa
                                            option(value=0) Inactiva   
                    .col-md-2.col-sm-12
                        label 
                        button.btn.bg-primary.text-light.btn-block(@click="Insert()") AGREGAR 
                            i.fa.fa-plus  
            .card-body.bg-light    
                .form-group
                        table.table.table-sm.table-borderedonlytable
                            thead.bg-table.text-white
                                th Editar
                                th Documento  
                                th Estado                       
                            tbody.bg-white(name="table-fade", is="transition-group") 
                                tr(v-if="tableInfo.length", v-for="(item,index) in tableInfo", :key="index")
                                    td
                                        button.btn.btn-sm.btn-info(v-if="item.Update==0", @click="item.Update = 1")     
                                            i.fa.fa-edit  
                                        button.btn.btn-sm.btn-warning(v-else, @click="item.Update = 0; Update(item)")     
                                            i.fa.fa-floppy-o
                                    td 
                                      |  {{item.NameDocument}}  
                                    td  
                                        div(v-if="item.Update == 0") {{item.Active==1 ? 'Activo':'Inactivo'}}
                                        select.form-control.form-control-sm(v-else, v-model="item.Active" , :disabled="item.Update==0 ? true:false")
                                            option(value=1) Activa
                                            option(value=0) Inactiva                        
                  
</template>
<script>
import modal from "../../../complementos/modal.vue" 
import model from "../../../models/userAccess.js" 
import apiWeb from "../../../api/apiSLC.js"
export default {
    props:{  
        IsShowModal:Boolean ,
        ItemSelect:Object 
    },  
    data(){
        return{
            nameModulo:'Acceso a Documentos',
            pathApi:'UserAccessDocument/UserAccessDocument', 
            parameterUpdate:Object.assign({}, model.parameterUpdate),
            parameterInsert:Object.assign({}, model.parameterInsert),
            parameterView:Object.assign({}, model.parameterView), 
            tablePending:[], 
            tableInfo:[]  
        }
    },
    components:{
        modal
    },
    computed:{
        isShowModal_ :{
                        get(){
                            this.Init()  
                            return this.IsShowModal 
                        },
                        set(val){
                            this.Init()  
                            this.$emit("update:IsShowModal",val)
                        }
        } 
    },
    mounted(){
    
    
    
    },
    methods:{
        Init(){
            this.parameterView.IdUser=this.ItemSelect.IdUser
            this.parameterView.IdEnterprise=this.$info.idEnterprise
            this.List_Info_Pending()
            this.List_Info()
        },
        List_Info_Pending(){ 
           this.parameterView.IdUser=this.ItemSelect.IdUser
           this.parameterView.IdEnterprise=this.$info.idEnterprise
            console.log(this.parameterView)
           apiWeb.post(this.pathApi + "_View_Peding",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tablePending=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        } ,
        List_Info(){
            console.log("paso")
           this.parameterView.IdUser=this.ItemSelect.IdUser
           this.parameterView.IdEnterprise=this.$info.idEnterprise
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0){
                                    this.tableInfo=JSON.parse(result.value) 
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        } ,
        Insert(){
            
            if(this.validate(this.parameterInsert)){ 
                this.parameterInsert.IdUser=this.ItemSelect.IdUser
                this.parameterInsert.IdEnterprise=this.$info.idEnterprise 
                this.parameterInsert.User=this.$info.email
                this.parameterInsert.IP=this.$info.ip
                apiWeb.post(this.pathApi +"_Insert",this.parameterInsert)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.List_Info_Pending()
                                    this.parameterInsert=Object.assign({}, model.parameterInsert) 
                                    this.$msgbox.show("Ingresado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                    this.List_Info()
                                    this.List_Info_Pending()
                                }

                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()
                                    this.List_Info_Pending()})
            }
            
        },
        Update(item){
            this.parameterUpdate.IdDocType=-12
            this.parameterUpdate.IdUserAccessDocument=item.IdUserAccessDocument 
            this.parameterUpdate.Active=item.Active 
            if(this.validate(this.parameterUpdate)){ 
                this.parameterUpdate.User=this.$info.email
                this.parameterUpdate.IP=this.$info.ip
                apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                        .then(result=>{ 
                                if(result.status==0){
                                    this.List_Info()
                                    this.IsShowModalUpdate=false
                                    this.$msgbox.show("Actualizado","Notificacion")
                                }
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                     this.List_Info()
                                }
                        })
                        .catch(ex=>{
                                    this.$msgbox.show(ex.message,"Error nivel 2")
                                    this.List_Info()})
            }
        },
        validate(parameter){ 
            console.log(parameter)
            if(parameter.IdDocType=='' || parameter.IdDocType==null ){
                this.$msgbox.show("Selecione Documento","Alerta")
                return false
            }
            else if(parameter.Active=='' || parameter.Active==null ){
                this.$msgbox.show("Selecione EStado","Alerta")
                return false
            }                   
            else{
                return true
            }
        }
    }

    
}
</script>